// extracted by mini-css-extract-plugin
module.exports = {"CallButtons":"CallButtons-module__CallButtons___K8oB-"};